import { Type } from '@angular/core';

export class CameraConfig<D = any> {
  data?: D;
  overlayType?: Type<any>;
}
